<template>
    <v-tabs
      class="pt-5 mb-md-2"
      v-if="datasource && this.$vuetify.breakpoint.smAndUp"
      :hide-slider="true"
      :height="'34px'"
      optional
      right
      :background-color="'#f7f8fa'"
    >
      <v-tab
        v-if="datasource.includeInNav.value == '1'"
        :to="datasource.url"
      >{{ this.datasource.name.value }}</v-tab>

      <v-tab v-for="(item, index) in subpages" :key="index" :to="item.url">{{ item.name.value }}</v-tab>
    </v-tabs>
</template>

<script>
import { isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'TopNavigation',
  data() {
    return {
    };
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
    data: {
      type: Object,
    },
    params: {
      type: Object,
    },
  },
  components: {},
  computed: {
    datasource() {
      let ds = this.fields.data && this.fields.data.datasource;
      if (process.env.VUE_APP_JssStandAlone === 'true') {
        const standaloneData = require('../../../data/graphQL/TopNavigation.json');
        ds = standaloneData.datasource;
      }
      return ds;
    },
    subpages() {
      let pages = [];
      if (this.datasource && this.datasource.children) {
        this.datasource.children.forEach((element) => {
          if (element.includeInNav!==null && element.includeInNav.value === '1') {
            pages.push(element);
          }
        });
      }
      return pages;
    },
    isExperienceEditor() {
      // Todo may need to add other check like preview mode in SC editor...
      return isExperienceEditorActive();
    },
  },
};
</script>
<style lang="scss" scoped>
.v-tabs {
  background-color: map-deep-get($colors, 'white-off', 'base') !important;
  ::v-deep {
    .v-slide-group__next {
      display: none !important;
    }
  }
}

.v-tab {
  font-size: 1.125rem !important;
  color: map-deep-get($colors, 'blue-text', 'base') !important;
  font-weight: map-get($font-weights, 'normal');
  letter-spacing: 0ch;
}
.theme--light.v-tabs .v-tab--active:before,
.theme--light.v-tabs .v-tab--active:hover:before,
.theme--light.v-tabs .v-tab:focus:before {
  opacity: 0 !important;
}
.v-tab:hover {
  color: map-deep-get($colors, 'blue-title', 'base') !important;
}

.v-tab:hover:before {
  background: none;
}

.v-slide-group__next .v-slide-group__next--disabled {
  display: none !important;
}

.v-tab--active {
  border-radius: 0;
  border-bottom: 4px solid map-deep-get($colors, 'blue-title', 'base');
  margin-top: 4px;
}
.back {
  color: map-deep-get($colors, 'blue-title', 'base');
  font-size: 16px;
  line-height: 2.1;
}
.icon {
  padding-bottom: 3px;
}
a {
  text-decoration: none;
}
</style>
